import AssessmentIcon from '@material-ui/icons/Assessment';
import ReplayIcon from '@material-ui/icons/Replay';
import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { ft3ReplayRouteRef, rootRouteRef } from './routes';

const gameplayAiPage = PageBlueprint.make({
  params: {
    routeRef: rootRouteRef,
    path: '/gameplayai',
    title: 'GameplayAI Status',
    icon: <AssessmentIcon />,
    loader: () =>
      import('./components/GameplayAiPage').then(module => (
        <module.GameplayAiPage />
      )),
  },
});

const ft3ReplayPage = PageBlueprint.make({
  name: 'ft3-replay',
  params: {
    routeRef: ft3ReplayRouteRef,
    path: '/ft3-replay',
    title: 'FT3 replay',
    icon: <ReplayIcon />,
    loader: () =>
      import('./components/Ft3ReplayPage').then(module => (
        <module.Ft3ReplayPage />
      )),
  },
});

export const gameplayAiPlugin = createFrontendPlugin({
  pluginId: 'gameplayai',
  title: 'GameplayAI Status',
  icon: <AssessmentIcon />,
  extensions: [gameplayAiPage, ft3ReplayPage],
  routes: { root: rootRouteRef, ft3Replay: ft3ReplayRouteRef },
  info: { packageJson: () => import('../package.json') },
});
